export default "__VITE_ASSET__42933cf4__"